import React, { useState, useEffect } from "react";
import Drawer from "@mui/material/Drawer";
import { TextField, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import { DeliverableStatus, ProjectDeliverableStatus } from "../../constants/Status";
import { AcceptFileType, Action } from "../../constants/Common";
import { useFormik } from "formik";
import * as Yup from "yup";
import { updateDeliverableStatus } from "../../api/casp/deliverable";
import { Spinner } from "reactstrap";
// import AttachFileIcon from '@material-ui/icons/AttachFile';
import { DocumentModule, Modules } from "../../constants/Module";
import { deleteDocument, documentList, documentListForProject, uploadFile } from "../../api/casp/document";
import Loader from "../Common/Loader";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
// import { makeStyles } from "@material-ui/core";
import DocumentFilePreviewModal from "../casp/common/DocumentFilePreviewModal";
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { getUrl } from "../../helpers/file_helper";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import CloseIcon from '@mui/icons-material/Close';
import { updateApprovalStatus } from "../../api/casp/approval";
import { middleTruncate } from "../../helpers/string_helper";

const useStyles = makeStyles({
  blueIcon: {
    color: '#296ced',
    cursor: 'pointer'
  },
});

const SubmitSecondDeliverableComment = ({
  isOpen,
  handleClose,
  selectedRow,
  refresh,
  isDisabled,
  action,
  // projectDetails,
  t
}) => {

  const [isLoading, setIsLoading] =
    useState(false);
  const [disabled, setDisabled] = useState(false);
  const [trigger, setTrigger] = useState(new Date())
  const [isOpenSweetAlert, setIsOpenSweetAlert] = useState(false);
  const [documentId, setDocumentId] = useState();
  const [deliverableObject, setDeliverableObject] = useState({
    name: selectedRow?.deliverable.name ?? "",
    startDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate ? selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate : selectedRow?.deliverable.startDate,
    endDate: selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate? selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate : selectedRow?.deliverable.endDate,
    description: selectedRow?.description ?? ""
  });
  const [filePath, setFilePath] = useState('');
  const [fileName, setFileName] = useState('');
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [modal, setModal] = useState(false);
  const classes = useStyles();
  const [loadingDocument, setLoadingDocument] = useState(false);

  const [businessModelLoading, setBusinessModelLoading] = useState(false);
  const [customerSegmentLoading, setCustomerSegmentLoading] = useState(false);
  const [propositionModelLoading, setPropositionModelLoading] = useState(false);
  const [virtualPersonalityLoading, setVirtualPersonalityLoading] = useState(false);
  const [marketSizeFileLoading, setMarketSizeLoading] = useState(false);
  const [exerciseFileLoading, setExerciseLoading] = useState(false);
  const [deletingFileType, setDeletingFileType] = useState('');
  const [businessModelFiles, setBusinessModelFiles] = useState([]);
  const [customerSegmentFiles, setCustomerSegmentFiles] = useState([]);
  const [propositionModelFiles, setPropositionModelFiles] = useState([]);
  const [virtualPersonalityFiles, setVirtualPersonalityFiles] = useState([]);
  const [MarketSizeFiles, setMarketSizeFiles] = useState([]);
  const [exerciseFiles, setExerciseFiles] = useState([]);

  const deliverableValidation = Yup.object().shape({
    businessModelComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    customerSegmentComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    propositionModelComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    customerPersonalityComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    marketSizeComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
    exerciseComment: Yup.string()
      .max(250, t("Too Long!"))
      .strict(true)
      .trim(t('Must not include leading and trailing spaces'))
      .optional(),
  });

  const formik = useFormik({
    initialValues: {
      businessModelComment: selectedRow?.deliverableRejectComments[0]?.businessModalComment ? selectedRow?.deliverableRejectComments[0]?.businessModalComment : "",
      customerSegmentComment: selectedRow?.deliverableRejectComments[0]?.customerSegmentAnalysisComment ? selectedRow?.deliverableRejectComments[0]?.customerSegmentAnalysisComment : "",
      propositionModelComment: selectedRow?.deliverableRejectComments[0]?.valuePropositionModelComment ? selectedRow?.deliverableRejectComments[0]?.valuePropositionModelComment : "",
      customerPersonalityComment: selectedRow?.deliverableRejectComments[0]?.virtualCustomerPersonalityComment ? selectedRow?.deliverableRejectComments[0]?.virtualCustomerPersonalityComment : "",
      marketSizeComment: selectedRow?.deliverableRejectComments[0]?.marketSizeComment ? selectedRow?.deliverableRejectComments[0]?.marketSizeComment : "",
      exerciseComment: selectedRow?.deliverableRejectComments[0]?.exercisesVariousAssumptionComment ? selectedRow?.deliverableRejectComments[0]?.exercisesVariousAssumptionComment : "",
    },
    validationSchema: deliverableValidation,
    validateOnMount: true,
  });

  useEffect(() => {
    if (selectedRow && action !== Action.EDIT) {
      getDocumentList()
    }
  }, [selectedRow]);

  const getDocumentList = async () => {
    try {
      // Set all loading states to true
      setBusinessModelLoading(true);
      setCustomerSegmentLoading(true);
      setPropositionModelLoading(true);
      setVirtualPersonalityLoading(true);
      setMarketSizeLoading(true);
      setExerciseLoading(true);

      const params = {
        projectId: selectedRow.projectId,
        filterFields: ['documentAssociations'],
        filterInputs: '',
        module: Modules.PROJECT_DELIVERABLE,
        moduleId: selectedRow.id
      };

      const documentData = await documentListForProject(params);
      const documentDataList = documentData.data.data;

      const filesByType = {
        'Business Model': [],
        'Customer Segment Analysis': [],
        'Value Proposition Model': [],
        'Virtual Customer Personality': [],
        'Market Size': [],
        'Exercises to verify Assumptions': [],
      };

      documentDataList.forEach(doc => {
        const type = doc.documentType.name;
        if (filesByType[type]) {
          filesByType[type].push(doc);
        }
      });

      setBusinessModelFiles(filesByType['Business Model']);
      formik.setFieldValue('businessModelAttachmentId', filesByType['Business Model'].map(f => f.id));

      setCustomerSegmentFiles(filesByType['Customer Segment Analysis']);
      formik.setFieldValue('customerSegmentAttachmentId', filesByType['Customer Segment Analysis'].map(f => f.id));

      setPropositionModelFiles(filesByType['Value Proposition Model']);
      formik.setFieldValue('propositionModelAttachmentId', filesByType['Value Proposition Model'].map(f => f.id));

      setVirtualPersonalityFiles(filesByType['Virtual Customer Personality']);
      formik.setFieldValue('customerPersonalityAttachmentId', filesByType['Virtual Customer Personality'].map(f => f.id));

      setMarketSizeFiles(filesByType['Market Size']);
      formik.setFieldValue('marketSizeAttachmentId', filesByType['Market Size'].map(f => f.id));

      setExerciseFiles(filesByType['Exercises to verify Assumptions']);
      formik.setFieldValue('exerciseAttachmentId', filesByType['Exercises to verify Assumptions'].map(f => f.id));

    } catch (err) {
      console.error(err);
    } finally {
      setBusinessModelLoading(false);
      setCustomerSegmentLoading(false);
      setPropositionModelLoading(false);
      setVirtualPersonalityLoading(false);
      setMarketSizeLoading(false);
      setExerciseLoading(false);
    }
  };

  const deliverableSubmit = async () => {
    try {
      setIsLoading(true);

      const payload = {
        deliverableComment: {
          businessModalComment: formik.values.businessModelComment,
          customerSegmentAnalysisComment: formik.values.customerSegmentComment,
          virtualCustomerPersonalityComment: formik.values.customerPersonalityComment,
          valuePropositionModelComment: formik.values.propositionModelComment,
          marketSizeComment: formik.values.marketSizeComment,
          exercisesVariousAssumptionComment: formik.values.exerciseComment,
        },
        status: ProjectDeliverableStatus.REJECTED,
        projectId: parseInt(selectedRow.projectId),
        moduleId: selectedRow.moduleId,
        module: selectedRow.actionType,
        deliverableOrder: selectedRow?.deliverable?.deliverableOrder
      };

      const res = await updateApprovalStatus(selectedRow?.approvalId, payload);

      if (res.statusCode === 200) {
        toast.success(res.data.message);
        refresh();
      } else {
        toast.error(res.message);
      }

      handleClose();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error(error.message);
    }
  };

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={handleClose}
        className="projectListDrawer"
        PaperProps={{
          sx: { width: "580px" },
        }}
      >
        <form className="editMilestoneDrawer p-3">
          <h5>{t("Deliverable")}</h5>
          <CloseIcon className="crossIcon" onClick={handleClose} />
          <div className="innerTbContent">
            <div className="row">
              {/* Name */}
              <div className="col-sm-12 mb-3">
                <TextField
                  fullWidth
                  id="outlined-basic"
                  label={t("Name")}
                  name="name"
                  value={selectedRow?.deliverable?.name}
                  inputProps={{
                    readOnly: isDisabled,
                  }}
                  required
                />
              </div>

              {/* Start Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.startDate && (
                      <DatePicker
                        label={t("Start Date") + " *"}
                        name="startDate"
                        format="MM/DD/YYYY"
                        value={
                          selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate?.toString().trim()
                            ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.startDate)
                            : dayjs(selectedRow?.deliverable?.startDate)
                        }
                        readOnly={
                          isDisabled
                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
              </div>
              {/* End Date */}
              <div className="col-sm-6 mb-3 plDatepicker">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DemoContainer components={["DatePicker"]}>
                    {deliverableObject.endDate && (
                      <DatePicker
                        label={t("End Date") + " *"}
                        name="endDate"
                        format="MM/DD/YYYY"
                        value={
                          selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate?.toString().trim()
                            ? dayjs(selectedRow?.deliverable?.PortfolioDeliverable[0]?.endDate)
                            : dayjs(selectedRow?.deliverable?.endDate)
                        }
                        readOnly={
                          isDisabled
                        }
                        required
                      />
                    )}
                  </DemoContainer>
                </LocalizationProvider>
              </div>

              {/* Description */}
              <div className="col-sm-12 mb-3">
                <>
                  <TextField
                    fullWidth
                    className="form-control"
                    id="deliverable-title-input"
                    label={t("Description")}
                    name="description"
                    value={selectedRow?.description}
                    disabled={isDisabled}
                    required
                    multiline
                    rows={2}
                  />
                </>
                {/* : <></>)} */}
              </div>

              {/* Business Model */}
              {/* <div className="col-sm-12 mb-3"> */}
                <>
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="businessModel"
                    label={t("Business Model")}
                    name="businessModel"
                    value={selectedRow?.businessModel}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="businessModel"
                      label={t("Business Model Comment")}
                      name="businessModelComment"
                      value={formik.values.businessModelComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      multiline
                      rows={3}
                      disabled={isLoading}
                    />
                    {formik.touched.businessModelComment && formik.errors.businessModelComment && (
                      <span className="text-danger">{formik.errors.businessModelComment}</span>
                    )}
                  </div> */}
                </>
              {/* </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  {!businessModelLoading && businessModelFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Business Model Document")}:</h5>
                  )}
                </div>

                <div>
                  {businessModelLoading && <Loader />}
                  {!businessModelLoading && businessModelFiles.length > 0 && businessModelFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                 <div className="mb-3 mt-1">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="businessModel"
                      label={t("Business Model Comment")}
                      name="businessModelComment"
                      value={formik.values.businessModelComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      multiline
                      rows={3}
                      disabled={isLoading}
                    />
                    {formik.touched.businessModelComment && formik.errors.businessModelComment && (
                      <span className="text-danger">{formik.errors.businessModelComment}</span>
                    )}
                  </div>
              </>

              {/* Customer Segment Analysis */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <> */}
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="customerSegment"
                    label={t("Customer Segment Analysis")}
                    name="customerSegment"
                    value={selectedRow?.customerSegmentAnalysis}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="customerSegment"
                      label={t("Customer Segment Analysis Comment")}
                      name="customerSegmentComment"
                      value={formik.values.customerSegmentComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      multiline
                      rows={3}
                      required
                    />
                    {formik.touched.customerSegmentComment && formik.errors.customerSegmentComment && (
                      <span className="text-danger">{formik.errors.customerSegmentComment}</span>
                    )}
                  </div>
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  {!customerSegmentLoading && customerSegmentFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Customer Segment Analysis Document")}:</h5>
                  )}
                </div>

                <div>
                  {customerSegmentLoading && <Loader />}
                  {!customerSegmentLoading && customerSegmentFiles.length > 0 && customerSegmentFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mb-3 mt-1">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="customerSegment"
                      label={t("Customer Segment Analysis Comment")}
                      name="customerSegmentComment"
                      value={formik.values.customerSegmentComment}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      multiline
                      rows={3}
                      required
                    />
                    {formik.touched.customerSegmentComment && formik.errors.customerSegmentComment && (
                      <span className="text-danger">{formik.errors.customerSegmentComment}</span>
                    )}
                  </div>
              </>


              {/* Value Proposition Model */}
              {/* <div className="col-sm-12 mb-3 mt-3"> */}
                {/* <> */}
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="propositionModel"
                    label={t("Value Proposition Model")}
                    name="propositionModel"
                    value={selectedRow?.valuePropositionModel}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="propositionModelComment"
                      label={t("Value Proposition Model Comment")}
                      name="propositionModelComment"
                      value={formik.values.propositionModelComment}
                      onChange={formik.handleChange}
                      multiline
                      rows={3}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      required
                    />
                    {formik.touched.propositionModelComment && formik.errors.propositionModelComment && (
                      <span className="text-danger">{formik.errors.propositionModelComment}</span>
                    )}
                  </div> */}
                {/* </>
              </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  {!propositionModelLoading && propositionModelFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Value Proposition Model Document")}:</h5>
                  )}
                </div>

                <div>
                  {propositionModelLoading && <Loader />}
                  {!propositionModelLoading && propositionModelFiles.length > 0 && propositionModelFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                 <div className="mb-3 mt-1">
                    <TextField
                      onWheel={(e) => e.target.blur()}
                      fullWidth
                      id="propositionModelComment"
                      label={t("Value Proposition Model Comment")}
                      name="propositionModelComment"
                      value={formik.values.propositionModelComment}
                      onChange={formik.handleChange}
                      multiline
                      rows={3}
                      onBlur={formik.handleBlur}
                      type="text"
                      disabled={isLoading}
                      required
                    />
                    {formik.touched.propositionModelComment && formik.errors.propositionModelComment && (
                      <span className="text-danger">{formik.errors.propositionModelComment}</span>
                    )}
                  </div>
              </>


              {/* Virtual Customer Personality */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <> */}
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="virtualCustomerPersonality"
                    label={t("Virtual Customer Personality")}
                    name="virtualCustomerPersonality"
                    value={selectedRow?.virtualCustomerPersonality}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                    <TextField
                    onWheel={(e) => e.target.blur()}
                      fullWidth
                      multiline
                      rows={3}
                    id="customerPersonality"
                    label={t("Virtual Customer Personality Comment")}
                    name="customerPersonalityComment"
                    value={formik.values.customerPersonalityComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.customerPersonalityComment && formik.errors.customerPersonalityComment && (
                    <span className="text-danger">{formik.errors.customerPersonalityComment}</span>
                  )}
                 </div> */}
                {/* </>
              </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  
                  {!virtualPersonalityLoading && virtualPersonalityFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Virtual Customer Personality Document")}:</h5>
                  )}
                </div>

                <div>
                  {virtualPersonalityLoading && <Loader />}
                  {!virtualPersonalityLoading && virtualPersonalityFiles.length > 0 && virtualPersonalityFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />                       
                      </div>
                    </div>
                  ))}
                </div>
                 <div className="mb-3 mt-1">
                    <TextField
                    onWheel={(e) => e.target.blur()}
                      fullWidth
                      multiline
                      rows={3}
                    id="customerPersonality"
                    label={t("Virtual Customer Personality Comment")}
                    name="customerPersonalityComment"
                    value={formik.values.customerPersonalityComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.customerPersonalityComment && formik.errors.customerPersonalityComment && (
                    <span className="text-danger">{formik.errors.customerPersonalityComment}</span>
                  )}
                 </div>
              </>


              {/* Market Size */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <> */}
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="marketSize"
                    label={t("Market Size")}
                    name="marketSize"
                    value={selectedRow?.marketSize}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                     <TextField
                    onWheel={(e) => e.target.blur()}
                      fullWidth
                      multiline
                      rows={3}
                    id="marketSize"
                    label={t("Market Size Comment")}
                    name="marketSizeComment"
                    value={formik.values.marketSizeComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.marketSizeComment && formik.errors.marketSizeComment && (
                    <span className="text-danger">{formik.errors.marketSizeComment}</span>
                  )}
                 </div>
                </>
              </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  {!marketSizeFileLoading && MarketSizeFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Market Size Document")}:</h5>
                  )}
                </div>

                <div>
                  {marketSizeFileLoading && <Loader />}
                  {!marketSizeFileLoading && MarketSizeFiles.length > 0 && MarketSizeFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
            
                      </div>
                    </div>
                  ))}
                </div>
                 <div className="mb-3 mt-1">
                     <TextField
                    onWheel={(e) => e.target.blur()}
                      fullWidth
                      multiline
                      rows={3}
                    id="marketSize"
                    label={t("Market Size Comment")}
                    name="marketSizeComment"
                    value={formik.values.marketSizeComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.marketSizeComment && formik.errors.marketSizeComment && (
                    <span className="text-danger">{formik.errors.marketSizeComment}</span>
                  )}
                 </div>
              </>


              {/* Exercises to verify assumptions */}
              {/* <div className="col-sm-12 mb-3 mt-3">
                <> */}
                  {/* <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                    id="exercise"
                    label={t("Exercises to verify Assumptions")}
                    name="exercise"
                    value={selectedRow?.exercisesVariousAssumption}
                    type="text"
                    disabled={isDisabled}
                    required
                  /> */}
                  {/* <div className="mt-3">
                     <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                      id="exercise"
                      multiline
                      rows={3}
                    label={t("Exercises to verify Assumptions Comment")}
                    name="exerciseComment"
                    value={formik.values.exerciseComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.exerciseComment && formik.errors.exerciseComment && (
                    <span className="text-danger">{formik.errors.exerciseComment}</span>
                  )}
                  </div> */}
                {/* </>
              </div> */}

              <>
                <div className="col-sm-12 mb-3">
                  {!exerciseFileLoading && exerciseFiles.length > 0 && (
                    <h5 className="mb-0 mt-2">{t("Attached Exercises to verify Assumptions Document")}:</h5>
                  )}
                </div>

                <div>
                  {exerciseFileLoading && <Loader />}
                  {!exerciseFileLoading && exerciseFiles.length > 0 && exerciseFiles.map((file, key) => (
                    <div className='d-flex mt-1 justify-content-between' key={key}>
                      <span className='fw-semibold text-truncate' title={file.name}>{middleTruncate(file.name)}</span>
                      <div className="actions">
                        <RemoveRedEyeOutlinedIcon
                          className={classes.blueIcon}
                          onClick={() => {
                            setModal(true);
                            setFilePath(getUrl(file.storageLink));
                            setFileName(middleTruncate(file.name));
                          }}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                 <div className="mb-3 mt-1">
                     <TextField
                    onWheel={(e) => e.target.blur()}
                    fullWidth
                      id="exercise"
                      multiline
                      rows={3}
                    label={t("Exercises to verify Assumptions Comment")}
                    name="exerciseComment"
                    value={formik.values.exerciseComment}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    disabled={isLoading}
                    required
                  />
                  {formik.touched.exerciseComment && formik.errors.exerciseComment && (
                    <span className="text-danger">{formik.errors.exerciseComment}</span>
                  )}
                  </div>
              </>
            </div>
          </div>
          {action === Action.SUBMIT && (
              <div className="plsubmitButton justify-content-center mt-4">
                <Button
                  onClick={deliverableSubmit}
                  disabled={
                  isLoading ||
                  !(formik.values?.businessModelComment || formik.values?.customerSegmentComment || formik.values?.propositionModelComment || formik.values?.marketSizeComment || formik.values?.exerciseComment || formik.values?.customerPersonalityComment)
                }
                  className="btn addNew_ProjectBtn"
                >
                  {isLoading && (
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-1"
                    />
                  )}
                  {t("Submit")}
                </Button>
              </div>
            )}
        </form>
      </Drawer>
      {modal && (
        <DocumentFilePreviewModal modal={modal} setModal={setModal} filePath={filePath} fileName={fileName} />
      )}
    </>
  );
};

export default withTranslation()(SubmitSecondDeliverableComment);
